import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const initialState = {
  authenticating: false,
  user: null
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
  getters
};
